import type { CollectionItem } from './types'

/**
 * Правила прогресса и состояний инвентаря.
 * Дубль этих правил живёт в `ios/Sticker/Models/Inventory.swift` и в
 * `inventory.service.ts` — меняете здесь, правьте во всех трёх.
 */

export type ItemState = 'missing' | 'owned' | 'duplicate'

export function itemState(item: CollectionItem): ItemState {
  if (item.haveCount === 0) return 'missing'
  return item.haveCount > 1 ? 'duplicate' : 'owned'
}

/// Прогресс считается от заявленного размера набора, а не от числа
/// заведённых в каталоге предметов: каталог наполняется постепенно.
export function progress(owned: number, total: number): number {
  if (total <= 0) return 0
  return Math.min(1, owned / total)
}

/// Сколько экземпляров реально свободно для обмена: первый остаётся
/// в альбоме.
export function tradableCount(item: CollectionItem): number {
  return Math.max(0, item.haveCount - 1)
}
